import { Label } from '@a-ui/react';
import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import GlobalStateMessage from '../../../components/GlobalStateMessage';
import LayoutTile from '../../../components/LayoutTile/LayoutTile';
import { translate } from '../../../i18n';
import { useAuthentication } from '../../../state/Authentication';
import { useMessage } from '../../../state/Message';
import { setMessage } from '../../../state/Message/actions';

const AccessKeys: React.FC = () => {
  const {
    state: { user, eID },
  } = useAuthentication();
  const { dispatch } = useMessage();
  const { search } = useLocation();

  useEffect(() => {
    const isEIDAdded = new URLSearchParams(search).get('eid_added');

    if (isEIDAdded === '1')
      dispatch(setMessage('accessKeys.eid.add.success', 'accessKeysOverview', 'success'));
  }, [search]);

  const emailValue = React.useMemo(() => {
    if (user.email?.candidate) {
      return <Label type="warning">{translate('common.value.pending')}</Label>;
    }

    if (user.emailPrimary) {
      return user.emailPrimary;
    }

    return <Label type="primary">{translate('common.value.missing')}</Label>;
  }, [user]);

  const phoneValue = React.useMemo(() => {
    if (user.phone?.candidate) {
      return <Label type="warning">{translate('common.value.pending')}</Label>;
    }

    if (user.phonePrimary) {
      return user.phonePrimary;
    }

    return <Label type="primary">{translate('common.value.missing')}</Label>;
  }, [user]);

  const eIDValue = React.useMemo(() => {
    if (eID?.rrnr) return eID.rrnr;

    return <Label type="primary">{translate('common.value.missing')}</Label>;
  }, [eID]);

  return (
    <>
      <GlobalStateMessage location="accessKeysOverview" />

      <LayoutTile
        to="/gegevens/aanmeldsleutels/e-mail"
        label={translate('accessKeys.overview.email.title')}
        toLabel={translate('accessKeys.overview.email.action')}
        value={emailValue}
      />

      <LayoutTile
        to="/gegevens/aanmeldsleutels/telefoon"
        label={translate('accessKeys.overview.phone.title')}
        toLabel={translate('accessKeys.overview.phone.action')}
        value={phoneValue}
      />

      <LayoutTile
        to="/gegevens/aanmeldsleutels/rijksregisternummer"
        label={translate('accessKeys.overview.eid.title')}
        toLabel={translate('accessKeys.overview.eid.action')}
        description={eID?.rrnr ? undefined : translate('accessKeys.overview.eid.description')}
        value={eIDValue}
      />
    </>
  );
};

export default AccessKeys;
